

exports.__esModule = true;
exports.$xoDeGuest = undefined;

var _angular = require('angular');

var _uiRouter = require('uiRouter');

var _squid = require('squid');

var _index = require('xo-models/src/checkout/index');

var _credit = require('xo-models/src/credit');

var $xoDeGuest = exports.$xoDeGuest = _squid.$ComponentRoute.extend('EndRoute', {
    path: 'xoDeGuest',
    resolve: {
        action: function action() {

            var models = {};
            var capeData = {};

            return (0, _squid.$populate)(models, {
                checkoutAppData: _index.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
                checkoutCart: _index.$CheckoutCartModel.instance(_angular.$rootScope.token),
                payee: _index.$CheckoutPayeeModel.instance(_angular.$rootScope.token)
            }).then(function () {
                var creditDataModel = _credit.$CreditDataModel.instance(_angular.$rootScope.token);

                return creditDataModel.action('readCreditKey', {
                    data: {
                        capeKey: creditDataModel.getCapeKey()
                    },
                    success: function success(res) {
                        capeData = res;
                        return (0, _squid.$populate)(models, {
                            creditDataModel: creditDataModel
                        });
                    },
                    contingencies: {
                        DEFAULT: _squid.$promise.reject
                    },
                    error: _squid.$promise.reject
                });
            }).then(function () {
                var financial_instrument_id = capeData.financial_instrument_id.indexOf('BC') !== 0 ? 'BC' + capeData.financial_instrument_id : capeData.financial_instrument_id;
                var checkoutSession = _index.$CheckoutSessionModel.instance(_angular.$rootScope.token);

                return checkoutSession.action('create', {
                    data: {
                        pmode: 'FAST',
                        preselected_fi: financial_instrument_id,
                        ftype: 'GUEST_ACQUISITION'
                    },
                    params: {
                        pmode: 'FAST',
                        preselected_fi: financial_instrument_id,
                        ftype: 'GUEST_ACQUISITION'
                    },
                    success: function success() {
                        return (0, _squid.$populate)(models, {
                            checkoutSession: checkoutSession
                        });
                    },
                    contingencies: {
                        DEFAULT: _squid.$promise.reject
                    },
                    error: _squid.$promise.reject
                });
            }).then(function () {
                return models.checkoutSession.action('authorize', {
                    data: {
                        pmode: 'FAST'
                    },
                    success: function success() {
                        _uiRouter.$state.go('checkout.end');
                    },
                    contingencies: {
                        DEFAULT: _squid.$promise.reject
                    },
                    error: _squid.$promise.reject
                });
            })['catch'](function () {
                return 'checkout.genericError';
            });
        }
    }
});

angular.value("$xoDeGuest", $xoDeGuest);
_angular.$rootScope;

_uiRouter.$state;

_squid.$ComponentRoute;

_squid.$populate;

_squid.$promise;

_index.$CheckoutAppDataModel;

_index.$CheckoutCartModel;

_index.$CheckoutPayeeModel;

_index.$CheckoutSessionModel;

_credit.$CreditDataModel;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-de-guest/route.js
// module id = ./pages/xo-de-guest/route.js
// module chunks = 0